import React, { PureComponent, Fragment } from 'react';
import { ModalTypes } from '../../constants/index.js';

class PinCodeMessage extends PureComponent {
  showPincodeModal = () => {
    this.props.showModal(ModalTypes.EDD_PINCODE, {});
  };

  render() {
    const {
      selectedSizeCode,
      edd: { activePincode, eddDetails, isEDDFetching }
    } = this.props;

    if (isEDDFetching) {
      return null;
    }
    let productSpecificEDDDetails = {};

    if (activePincode && selectedSizeCode && eddDetails[activePincode]) {
      productSpecificEDDDetails = eddDetails[activePincode][selectedSizeCode];
    }

    const { servicability, reasonForNotServiceability } = productSpecificEDDDetails || {};

    return (
      <div className="edd-pincode-msg">
        {servicability === undefined && (
          <div className="edd-pincode-msg-container" tabIndex={0}>
            <span className="ic-address edd-pincode-msg-address-icon" aria-hidden="true" />
            {(selectedSizeCode.length && (
              <span
                className="edd-pincode-msg-details edd-pincode-msg-details-pointer edd-pincode-msg-details-text-color"
                onClick={this.showPincodeModal}
                role="button"
              >
                Enter Pin-code To Know Estimated Delivery Date
              </span>
            )) || (
              <span className="edd-pincode-msg-details" >
                Select your size to know your estimated delivery date.
              </span>
            )}
          </div>
        )}
        {servicability === false && (
          <div className="edd-pincode-msg-container">
            <span className="ic-address edd-pincode-msg-address-icon" aria-hidden="true" />
            <div className="edd-pincode-msg-details edd-pincode-msg-details-not-deliverable">
              {reasonForNotServiceability === 'NS' && (
                <div>
                  Selected size is not deliverable to{' '}
                  <span className="edd-pincode-msg-details-not-deliverable-pincode">
                    {activePincode}
                  </span>
                </div>
              )}
              {reasonForNotServiceability === 'OOS' && (
                <div >
                  This product is not deliverable to your location or out of stock{' '}
                  <span className="edd-pincode-msg-details-not-deliverable-pincode">
                    {activePincode}
                  </span>
                </div>
              )}
            </div>
          </div>
        )}
        {servicability !== undefined && (
          <span            
            tabIndex={0}
            role='button'
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.showPincodeModal();
              }
            }}
            onClick={this.showPincodeModal}
            className={`${
              servicability === true ? ' right-align ' : ''
            } edd-pincode-msg-change-address`}
          >
            Change Pincode
          </span>
        )}
      </div>
    );
  }
}

export default PinCodeMessage;
